/**
 * This component override VTooltip in order to fix following bug:
 * When cursor hover a VTooltip component, and at the same time
 * the VTooltip is becoming invisible for some reason, the tooltip
 * content will still show up on the left-top corner and can't not be removed.
*/
<script>
import Vue from 'vue';

let VTooltip = Vue.options.components['VTooltip'];

export default {
  extends: VTooltip,
  data() {
    return {
      isVisible: false
    };
  },

  watch: {
    isVisible(v) {
      clearTimeout(this._inactiveTimeout);
      if (!v) {
        // default delay time of VTooltip showup is 200ms, so we must dislabe it with a greater delay time.
        this._inactiveTimeout = setTimeout(() => this.isActive = false, 210);
      }
    }
  },

  mounted() {
    let opt = {threshold: 0.9};
    this._intersectionObserver = new IntersectionObserver((entries, observer) => {
      let isVisible = true;
      entries.forEach(entry => {
        isVisible = entry.intersectionRatio >= 0.9 && isVisible;
      });
      this.isVisible = isVisible;
    }, opt);
    this._intersectionObserver.observe(this.$el);
  },

  beforeDestroy() {
    this._intersectionObserver.disconnect();
  }
};
</script>